<template>
       <el-dialog :title="type=='1'?'银行账号' : '固定电话'"  v-model="farmShow" width="800px"  @close="handleCancle()">
             <div style="height: 30px;position: relative;top:-20px;font-size: 16px;">
                             <div style="float:left;margin-left: 30px; margin-right: 20px;margin-top: 10px;">关键字</div>
                             <el-input v-model="query.keyword"  style="width: 480px;height: 40px!important;"></el-input>
                              <el-button
                                    style="float: right;margin-right: 20px;margin-top: 5px;"
                                    size="small"
                                    type="primary"
                                    @click="toSearch()">
                                    查询
                                </el-button>
                                 <el-button
                                   style="float: right;margin-right: 20px;margin-top: 5px;"
                                    size="small"
                                    type="warning"
                                    @click="toAdd()">
                                    新增
                                </el-button>
             </div>
             <el-table
                :data="farmData"
                border
                :max-height="800"
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header">
                <el-table-column
                    v-for="col in farmCols"
                    :key="col.prop"
                    :prop="col.prop"
                    :label="col.label"
                    :width="col.width"
                    :align="col.align">
                        <template #default="scope">
                            <div v-if="scope.column.property ==='Type'">

                            </div>
                            <div v-else-if="scope.column.property ==='Operation'">
                                <el-button
                                    v-if="flag==0"
                                    size="mini"
                                    type="danger"
                                    @click="handleCancle(scope.row)">
                                    选中
                                </el-button>
                                  <el-button
                                    v-if="flag==1"
                                    size="mini"
                                    type="danger"
                                    @click="handleDelete(scope.row.Id)">
                                    删除
                                </el-button>
                            </div>
                            <div v-else>
                                {{scope.row[scope.column.property]}}
                            </div>
                        </template>
                    </el-table-column>
            </el-table>
             <div class="pagination">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange"
                    :current-page="query.pageIndex"
                    :page-sizes="[5, 10, 20, 40]"
                    :page-size="query.pageSize"
                    layout="total, sizes, prev, pager, next"
                    :total="pageTotal">
                </el-pagination>
            </div>
        </el-dialog>
        <el-dialog title="新增" v-model="detailVisible" width="600px" top="20vh">
            <el-form ref="detailForm"  :model="dataDetail" label-width="160px">
                <el-row  v-if="type==1">
                    <el-col :span="22">
                        <el-form-item label="开户行名称：">
                             <el-input
                                v-model="dataDetail.NBZHKHH"
                                size="small"
                                placeholder="请输入名称"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="22">
                        <el-form-item label="账号：">
                             <el-input
                                v-model="dataDetail.NBYHZH"
                                size="small"
                                placeholder="请输入账号"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                   <el-row  v-else>
                    <el-col :span="22">
                        <el-form-item label="银行名称：">
                             <el-input
                                v-model="dataDetail.NBZHKHH"
                                size="small"
                                placeholder="请输入名称"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="22">
                        <el-form-item label="固定电话：">
                             <el-input
                                v-model="dataDetail.NBYHZH"
                                size="small"
                                placeholder="请输入账号"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
                <div style="height: 30px;margin-left: 420px;">
                    <el-button size="small" @click="detailVisible = false">取 消</el-button>
                    <el-button size="small" type="primary" @click="addBankAccount">提交</el-button>
                </div>
        </el-dialog>
</template>

<script>
import apis from "../api/yj";
export default {
    name: "account",
    props: {
        isShow: {
		type: Boolean,
        required:true,
        default:false
	     },
         flag: {
		type: String,
        required:false,
        default:0
	     },
        type: {
		type: String,
        required:false,
        default:1
	     },
          bankId: {
		type: Number,
        required:false,
        default:0
	     },
   },
    data() {
        return {
            dataDetail:{},
            detailVisible:false,
            farmShow:this.isShow,
            farmData:[],
            pageTotal: 0,
            farmCols:[],
            query: {
                keyword: "",
                pageIndex: 1,
                pageSize: 5
            },
        };
    },
     watch:{
        isShow(val){
            if(val){
                this.farmData=[];
                this.pageTotal=0;
                this.farmShow=this.isShow;
                this.query={
                keyword: "",
                pageIndex: 1,
                pageSize: 5
                 };
                this.toSearch();
            }
        
      }
     },
     methods: {
        toAdd(){
           this.detailVisible=true;
          this.dataDetail={
            NBZHKHH:"",
            NBYHZH:"",
            Type:this.type,
          }
          if(this.type==1)this.dataDetail.BankID=this.bankId;
        },
        addBankAccount(){
            var param=this.dataDetail;
            var that=this;
            if(!param.NBZHKHH||!param.NBYHZH){
               that.$message.error("内容不可为空");
                return;
            }
        apis.addBankAccount(param).then(res => {
          if(res){
           that.$message.success("新增成功");
             that.toSearch();
             that.detailVisible=false;
          }else {
            that.$message.error("新增失败");
          }
        });
      },
       handleDelete(Id){
        var param={Id:Id,IsDelete:1}
         var that=this;
         apis.updateBankAccount(param).then(res => {
                        if(res){
                         that.$message.success("删除成功");
                           that.toSearch();
                        }else{
                          that.$message.error("删除失败");
                        }
                    });
      },
        toSearch(){
            let that = this;
            var queryPara={
                keyword:that.query.keyword,
                bankId:this.bankId,
                type:this.type,
                pageIndex:this.query.pageIndex,
                pageSize:this.query.pageSize
            };
            if(this.type==2){
                queryPara.bankId=null;
                this.farmCols=[
                {
                    "prop": "NBZHKHH",
                    "label": "名称",
                    "width": "",
                    "align": "center"
                },
                {
                    "prop": "NBYHZH",
                    "label": "固定电话",
                    "width": "200",
                    "align": "center"
                },
                {
                    "prop": "Operation",
                    "label": "操作",
                    "width": "100",
                    "align": "center"
                }
            ]
            }else  this.farmCols=[
                {
                    "prop": "NBZHKHH",
                    "label": "开户行",
                    "width": "",
                    "align": "center"
                },
                {
                    "prop": "NBYHZH",
                    "label": "账号",
                    "width": "200",
                    "align": "center"
                },
                {
                    "prop": "Operation",
                    "label": "操作",
                    "width": "100",
                    "align": "center"
                }
            ]
            apis.getBankAccountList(queryPara).then(res => {
                that.farmData = res.list;
                that.pageTotal=res.count
            });
          },
        handleCancle(value){
            this.farmShow=false
            this.$emit('transfer',value)
          },
         handlePageChange(val) {
            this.query.pageIndex = val;
            this.toSearch();
        },
        handleSizeChange(val){
            this.query.pageIndex = 1;
            this.query.pageSize = val;
            this.toSearch();
        },
          
     }
     
};
</script>

<style scoped>


</style>
